<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <v-tabs fixed-tabs v-model="selectedTab">
      <v-tab
        v-on:click.native="submitVrednosti"
        style="padding-left: 20px; padding-right: 20px"
        >UBRANa količina</v-tab
      >
      <v-tab
        v-on:click.native="submitKolicine"
        style="padding-left: 20px; padding-right: 20px"
        >UTROŠCI PO TONI</v-tab
      >
      <v-tab
        v-on:click.native="submitObracun"
        style="padding-left: 20px; padding-right: 20px"
        >OBRAČUN cene</v-tab
      >
    </v-tabs>

    <div class="Actions__Content" style="padding:0px !important;">
      <div class="DataTable">
        <div fluid style="padding-bottom: 10px" v-if="selectedTab !== 2">
          <v-layout row wrap style="padding-top: 0px !important">
            <v-flex xs12 pa-2 class="flex-center">
              <v-radio-group
                v-model="radios"
                row
                style="padding: 0px !important; margin: 0px"
                v-on:change="preracunajVrednostiZaStampu"
                v-if="selectedTab === 0"
              >
                <v-radio label="Ukupno" value="0"></v-radio>
                <v-radio :label="labPocokotu" value="1"></v-radio>
                <v-radio label="Po hektaru" value="2"></v-radio>
              </v-radio-group>
              <v-radio-group
                v-model="radios"
                row
                style="padding: 0px !important; margin: 0px"
                v-on:change="preracunajVrednostiZaStampu"
                v-else
              >
                <v-radio label="Vrednosti" value="0"></v-radio>
                <v-radio label="Količine" value="1"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="padding-top: 0px !important; max-height: 1000px !important"
          >
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuOd"
                v-model="menuOd"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedOd"
                  label="Datum od"
                  readonly
                  @blur="dateOd = parseDate(dateFormattedOd)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateOd"
                  no-title
                  @input="menuOd = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateOd = null;
                    $refs.menuOd.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuDo"
                v-model="menuDo"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedDo"
                  label="Datum do"
                  readonly
                  @blur="dateDo = parseDate(dateFormattedDo)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateDo"
                  no-title
                  @input="menuDo = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateDo = null;
                    $refs.menuDo.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex xs7> </v-flex>
            <v-flex xs1 style="text-align: right">
              <v-btn
                @click="submit"
                class="AppButtonFilled"
                style="margin-top: 15px"
                >Pretraži</v-btn
              >
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-layout>
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <!-- multiple
                chips
                deletable-chips
                hide-no-data
                outlined
                dense -->
                <v-autocomplete
                  v-model="vineyard_select"
                  :items="vineyard_items"
                  item-text="name"
                  item-value="id"
                  :label="labVinograd"
                  persistent-hint
                  return-object
                  clearable
                  ref="element1"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="grape_variety_select"
                  :items="grape_variety_items"
                  item-text="name"
                  item-value="id"
                  label="Sorta"
                  persistent-hint
                  return-object
                  ref="element2"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="grapeVarietyId"
                ref="dTable"
                expand
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
                v-if="selectedTab === 0"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.grapeVarietyId;
                          })
                          .indexOf(props.item.grapeVarietyId) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 35%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{ props.item.grapeVariety }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.numberOfPlants !== 0"
                    >
                      {{ currencyFormat(props.item.numberOfPlants) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.surface !== 0"
                    >
                      {{ currencyFormatDE(props.item.surface) }} ha
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.harvestQuantityInT !== 0"
                    >
                      {{
                        radios === "0"
                          ? currencyFormatDE(props.item.harvestQuantityInT) +
                            " t"
                          : radios === "1"
                          ? currencyFormatDE(
                              (props.item.harvestQuantityInT * 1000) /
                                props.item.numberOfPlants
                            ) + " kg"
                          : currencyFormatDE(
                              props.item.harvestQuantityInT / props.item.surface
                            ) + " t"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 20%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                  </tr>
                </template>

                <template slot="expand" slot-scope="props">
                  <template>
                    <table class="topics" style="background: #f3f7f4">
                      <tr
                        v-for="(item, index) in props.item.vineyardDataDtos"
                        :key="index"
                      >
                        <td
                          style="
                            width: 35%;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ item.vineyard }}
                        </td>

                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.numberOfPlants !== 0"
                        >
                          {{ currencyFormat(item.numberOfPlants) }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.surfaceInHa !== 0"
                        >
                          {{ currencyFormatDE(item.surfaceInHa) }} ha
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.harvestQuantityInT !== 0"
                        >
                          {{
                            radios === "0"
                              ? currencyFormatDE(item.harvestQuantityInT) + " t"
                              : radios === "1"
                              ? currencyFormatDE(
                                  (item.harvestQuantityInT * 1000) /
                                    item.numberOfPlants
                                ) + " kg"
                              : currencyFormatDE(
                                  item.harvestQuantityInT / item.surfaceInHa
                                ) + " t"
                          }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>

                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
                <template slot="footer">
                  <td></td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    Ukupno:
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalCokota !== 0"
                  >
                    {{ currencyFormat(totalCokota) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalPovrsina !== 0"
                  >
                    {{ currencyFormatDE(totalPovrsina) }} ha
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalUbrano !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalUbrano) + " t"
                        : radios === "1"
                        ? currencyFormatDE((totalUbrano * 1000) / totalCokota) +
                          " kg"
                        : currencyFormatDE(totalUbrano / totalPovrsina) + " t"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                </template>
              </v-data-table>

              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="grapeVarietyId"
                ref="dTable"
                expand
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
                v-else-if="selectedTab === 1"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.grapeVarietyId;
                          })
                          .indexOf(props.item.grapeVarietyId) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{ props.item.grapeVariety }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.numberOfPlants !== 0"
                    >
                      {{ currencyFormat(props.item.numberOfPlants) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.surface !== 0"
                    >
                      {{ currencyFormatDE(props.item.surface) }} ha
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.harvestQuantityInT !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.harvestQuantityInT) + " t"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="radios === '0'"
                    >
                      {{
                        props.item.materialCosts !== 0
                          ? currencyFormatDE(
                              props.item.materialCosts /
                                props.item.harvestQuantityInT
                            ) + " RSD"
                          : "-"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{
                        props.item.interanlMechanizationHours !== 0
                          ? convertMinToTime(
                              props.item.interanlMechanizationHours /
                                props.item.harvestQuantityInT
                            ) + " h"
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.externalMechanizationCosts !== 0"
                    >
                      {{
                        radios === "0"
                          ? currencyFormatDE(
                              props.item.externalMechanizationCosts /
                                props.item.harvestQuantityInT
                            ) + " RSD"
                          : convertMinToTime(
                              props.item.exteranlMechanizationHours /
                                props.item.harvestQuantityInT
                            ) + " h"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      v-if="radios === '1'"
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{
                        props.item.interanlWorkForceHours !== 0
                          ? convertMinToTime(
                              props.item.interanlWorkForceHours /
                                props.item.harvestQuantityInT
                            ) + " h"
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.externalWorkForceCosts !== 0"
                    >
                      {{
                        radios === "0"
                          ? currencyFormatDE(
                              props.item.externalWorkForceCosts /
                                props.item.harvestQuantityInT
                            ) + " RSD"
                          : convertMinToTime(
                              props.item.exteranlWorkForceHours /
                                props.item.harvestQuantityInT
                            ) + " h"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.fuelConsumption !== 0"
                    >
                      {{
                        radios === "0"
                          ? currencyFormatDE(
                              props.item.fuelCosts /
                                props.item.harvestQuantityInT
                            ) + " RSD"
                          : currencyFormatDE(
                              props.item.fuelConsumption /
                                props.item.harvestQuantityInT
                            ) + " l"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="radios === '1'"
                    >
                      {{
                        currencyFormatDE(
                          props.item.waterConsumption /
                            props.item.harvestQuantityInT
                        )
                      }}
                      l
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-else
                    >
                      {{
                        currencyFormatDE(
                          (props.item.fuelCosts +
                            props.item.externalWorkForceCosts +
                            props.item.externalMechanizationCosts +
                            props.item.materialCosts) /
                            props.item.harvestQuantityInT
                        )
                      }}
                      RSD
                    </td>
                  </tr>
                </template>

                <template slot="expand" slot-scope="props">
                  <template>
                    <table class="topics" style="background: #f3f7f4">
                      <tr
                        v-for="(item, index) in props.item
                          .vineyardPerGrapeVarietyData"
                        :key="index"
                      >
                        <td
                          style="
                            width: 10%;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ item.vineyard }}
                        </td>

                        <td
                          style="
                            width: 9%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.numberOfPlants !== 0"
                        >
                          {{ currencyFormat(item.numberOfPlants) }}
                        </td>
                        <td
                          style="
                            width: 9%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          style="
                            width: 9%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.surfaceInHa !== 0"
                        >
                          {{ currencyFormatDE(item.surfaceInHa) }} ha
                        </td>
                        <td
                          style="
                            width: 9%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                          v-if="item.harvestQuantityInT !== 0"
                        >
                          {{ currencyFormatDE(item.harvestQuantityInT) + " t" }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                          v-if="radios === '0'"
                        >
                          {{
                            item.materialCosts !== 0
                              ? currencyFormatDE(
                                  item.materialCosts / item.harvestQuantityInT
                                ) + " RSD"
                              : "-"
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                        >
                          {{
                            item.interanlMechanizationHours !== 0
                              ? convertMinToTime(
                                  item.interanlMechanizationHours /
                                    item.harvestQuantityInT
                                ) + " h"
                              : "-"
                          }}
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                          v-if="item.externalMechanizationCosts !== 0"
                        >
                          {{
                            radios === "0"
                              ? currencyFormatDE(
                                  item.externalMechanizationCosts /
                                    item.harvestQuantityInT
                                ) + " RSD"
                              : convertMinToTime(
                                  item.exteranlMechanizationHours /
                                    item.harvestQuantityInT
                                ) + " h"
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                        >
                          -
                        </td>
                        <td
                          v-if="radios === '1'"
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 9%;
                          "
                          @click="props.expanded = !props.expanded"
                        >
                          {{
                            item.interanlWorkForceHours !== 0
                              ? convertMinToTime(
                                  item.interanlWorkForceHours /
                                    item.harvestQuantityInT
                                ) + " h"
                              : "-"
                          }}
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 10%;
                          "
                          @click="props.expanded = !props.expanded"
                          v-if="item.externalWorkForceCosts !== 0"
                        >
                          {{
                            radios === "0"
                              ? currencyFormatDE(
                                  item.externalWorkForceCosts /
                                    item.harvestQuantityInT
                                ) + " RSD"
                              : convertMinToTime(
                                  item.exteranlWorkForceHours /
                                    item.harvestQuantityInT
                                ) + " h"
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 10%;
                          "
                          @click="props.expanded = !props.expanded"
                        >
                          -
                        </td>
                        <td
                          style="
                            width: 10%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.fuelConsumption !== 0"
                        >
                          {{
                            radios === "0"
                              ? currencyFormatDE(
                                  item.fuelCosts / item.harvestQuantityInT
                                ) + " RSD"
                              : currencyFormatDE(
                                  item.fuelConsumption / item.harvestQuantityInT
                                ) + " l"
                          }}
                        </td>
                        <td
                          style="
                            width: 10%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>

                        <td
                          style="
                            width: 10%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="radios === '1'"
                        >
                          {{
                            currencyFormatDE(
                              item.waterConsumption / item.harvestQuantityInT
                            ) + " l"
                          }}
                        </td>
                        <td
                          style="
                            width: 10%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          {{
                            currencyFormatDE(
                              (item.fuelCosts +
                                item.externalWorkForceCosts +
                                item.externalMechanizationCosts +
                                item.materialCosts) /
                                item.harvestQuantityInT
                            ) + " RSD"
                          }}
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>

                <template slot="no-data">
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
                <template slot="footer">
                  <td></td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    Ukupno:
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalCokota !== 0"
                  >
                    {{ currencyFormat(totalCokota) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalPovrsina !== 0"
                  >
                    {{ currencyFormatDE(totalPovrsina) }} ha
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalUbrano !== 0"
                  >
                    {{ currencyFormatDE(totalUbrano) }} t
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalSopstveneMasine !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalSopstveneMasine / totalUbrano) +
                          " RSD"
                        : convertMinToTime(totalSopstveneMasine / totalUbrano) +
                          " h"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalEksterneMasine !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalEksterneMasine / totalUbrano) +
                          " RSD"
                        : convertMinToTime(totalEksterneMasine / totalUbrano) +
                          " h"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalSopstveniRadnici !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(
                            totalSopstveniRadnici / totalUbrano
                          ) + " RSD"
                        : convertMinToTime(
                            totalSopstveniRadnici / totalUbrano
                          ) + " h"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalEksterniRadnici !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalEksterniRadnici / totalUbrano) +
                          " RSD"
                        : convertMinToTime(totalEksterniRadnici / totalUbrano) +
                          " h"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalGoriva !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalGoriva / totalUbrano) + " RSD"
                        : currencyFormatDE(totalGoriva / totalUbrano) + " l"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="radios === '1'"
                  >
                    {{ currencyFormatDE(totalVoda / totalUbrano) }}
                    l
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    {{
                      totalGoriva +
                        totalEksterniRadnici +
                        totalEksterneMasine +
                        totalSopstveneMasine ===
                      0
                        ? "-"
                        : currencyFormatDE(
                            (totalGoriva +
                              totalEksterniRadnici +
                              totalEksterneMasine +
                              totalSopstveneMasine) /
                              totalUbrano
                          ) + " RSD"
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <div style="padding-bottom: 10px" v-else>
          <v-form ref="form1">
            <v-layout>
              
              
              
              <!-- <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="submitIzmeniObracun"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  >Izračunaj</v-btn
                >
              </v-flex> -->
            </v-layout>
            <v-layout>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                  <v-autocomplete
              v-model="godina_select"
              :items="godina_items"
              
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Godina berbe"
              required
              ref="element11"
              
              v-on:change="getSifarnik"
              clearable
            >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs9
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
              </v-flex>
              <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="submitIzmeniObracun"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  :disabled="!izmena"
                  >Izračunaj</v-btn
                >
              </v-flex>
              </v-layout> 
            <v-layout>
              

              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-text-field
                  v-model="workforcePricePerH"
                  label="Prosečna cena rada po h"
                  type="number"
                  v-on:change="sadIdeIzmena"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-text-field
                  v-model="mechanizationAmortizationAmount"
                  label="Amortizacija mehanizacije i opreme"
                  type="number"
                  v-on:change="sadIdeIzmena"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-text-field
                  v-model="waterPricePerM3"
                  label="Cena vode po m3"
                  type="number"
                  v-on:change="sadIdeIzmena"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-text-field
                  v-model="vineyardAmortizationAmount"
                  label="Amortizacija vinograda"
                  type="number"
                  v-on:change="sadIdeIzmena"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-text-field
                  v-model="otherCostsAmount"
                  label="Ostali troškovi"
                  type="number"
                  suffix="RSD"
                  v-on:change="sadIdeIzmena"
                ></v-text-field>
              </v-flex>
              <v-flex xs1 style="text-align: right"> </v-flex>
            </v-layout>

            <v-layout>
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <!-- multiple
                chips
                deletable-chips
                hide-no-data
                outlined
                dense -->
                <v-autocomplete
                  v-model="vineyard_select"
                  :items="vineyard_items"
                  item-text="name"
                  item-value="id"
                  :label="labVinograd"
                  persistent-hint
                  return-object
                  clearable
                  ref="element1"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="getSifarnikDodajParametre"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  >Primeni</v-btn
                >
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="grape_variety_select"
                  :items="grape_variety_items"
                  item-text="name"
                  item-value="id"
                  label="Sorta"
                  persistent-hint
                  return-object
                  ref="element2"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>

          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                item-key="grapeVarietyId"
                ref="dTable"
                expand
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
                class="TankTable"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      :style="vrati_style(header.text)"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.grapeVarietyId;
                          })
                          .indexOf(props.item.grapeVarietyId) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 9%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      {{ props.item.grapeVariety }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.numberOfPlants !== 0"
                    >
                      {{ currencyFormat(props.item.numberOfPlants) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.surface !== 0"
                    >
                      {{ currencyFormatDE(props.item.surface) }} ha
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.harvestQuantityInT !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.harvestQuantityInT) + " t"
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 5%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.material !== 0"
                    >
                      {{ currencyFormatDE(props.item.material) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.internalWorkForce !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.internalWorkForce)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.externalWorkForce !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.externalWorkForce)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.internalMechanization !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.internalMechanization)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.externalMechanization !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.externalMechanization)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 7%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 4%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.fuel !== 0"
                    >
                      {{ currencyFormatDE(props.item.fuel) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 4%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 4%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.water !== 0"
                    >
                      {{ currencyFormatDE(props.item.water) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 4%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.vineyardAmortization !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.vineyardAmortization)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 8%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 6%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.otherCosts !== 0"
                    >
                      {{ currencyFormatDE(props.item.otherCosts) }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 6%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 20px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.grapePricePerKg !== 0"
                    >
                      {{
                        currencyFormatDE(props.item.grapePricePerKg)
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: right;
                        padding-left: 0px;
                        padding-right: 0px;
                        width: 10%;
                      "
                      @click="props.expanded = !props.expanded"
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: center;
                        width: 2%;
                        padding-left: 0px;
                        padding-right: 0px;
                      "
                    >
                      <img
                        title="Grafički pregled troškova"
                        src="../assets/Ikone/icons8-increase-24_bela.png"
                        alt="ulaz-grozdja"
                        @click="submit_parameterGrafic(props.item)"
                      />
                    </td>
                  </tr>
                </template>

                <template slot="expand" slot-scope="props">
                  <template>
                    
                    <table
                      class="topics"
                      style="
                        background: #f3f7f4;
                      "
                    >
                      <tr
                        v-for="(item, index) in props.item
                          .vineyardPerGrapeVarietyData"
                        :key="index"
                      >
                        <td
                          style="
                            width: 9%;
                            padding-left: 0px;
                            padding-right: 0px;
                          "
                        >
                          {{ item.vineyard }}
                        </td>

                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                          v-if="item.numberOfPlants !== 0"
                        >
                          {{ currencyFormat(item.numberOfPlants) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                          v-if="item.surface !== 0"
                        >
                          {{ currencyFormatDE(item.surfaceInHa) }} ha
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                          v-if="item.harvestQuantityInT !== 0"
                        >
                          {{ currencyFormatDE(item.harvestQuantityInT) + " t" }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 5%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                          v-if="item.material !== 0"
                        >
                          {{ currencyFormatDE(item.material) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                          v-if="item.internalWorkForce !== 0"
                        >
                          {{
                            currencyFormatDE(item.internalWorkForce)
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                          v-if="item.externalWorkForce !== 0"
                        >
                          {{
                            currencyFormatDE(item.externalWorkForce)
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                          v-if="item.internalMechanization !== 0"
                        >
                          {{
                            currencyFormatDE(item.internalMechanization)
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                          v-if="item.externalMechanization !== 0"
                        >
                          {{
                            currencyFormatDE(item.externalMechanization)
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 7%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 4%;
                          "
                          v-if="item.fuel !== 0"
                        >
                          {{ currencyFormatDE(item.fuel) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 4%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 4%;
                          "
                          v-if="item.water !== 0"
                        >
                          {{ currencyFormatDE(item.water) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 4%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                          v-if="item.vineyardAmortization !== 0"
                        >
                          {{
                            currencyFormatDE(item.vineyardAmortization)
                          }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 8%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 6%;
                          "
                          v-if="item.otherCosts !== 0"
                        >
                          {{ currencyFormatDE(item.otherCosts) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 6%;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 20px;
                            width: 10%;
                          "
                          v-if="item.grapePricePerKg !== 0"
                        >
                          {{ currencyFormatDE(item.grapePricePerKg) }}
                        </td>
                        <td
                          v-else
                          style="
                            text-align: right;
                            padding-left: 0px;
                            padding-right: 0px;
                            width: 10%;
                          "
                        >
                          -
                        </td>
                        <td
                        style="
                        text-align: center;
                        width: 2%;
                        padding-left: 0px;
                        padding-right: 0px;
                      "
                        >
                          <img
                            title="Grafički pregled troškova"
                            src="../assets/Ikone/icons8-increase-24_bela.png"
                            alt="ulaz-grozdja"
                            @click="submit_parameterGrafic2(item, props.item)"
                          />
                        </td>
                      </tr>
                    </table>
                
                    </template>
                  </template>

                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
                <!-- <template slot="footer">
                  <td></td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    Ukupno:
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalCokota !== 0"
                  >
                    {{ currencyFormat(totalCokota) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalPovrsina !== 0"
                  >
                    {{ currencyFormatDE(totalPovrsina) }} ha
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalUbrano !== 0"
                  >
                    {{
                      radios === "0"
                        ? currencyFormatDE(totalUbrano) + " t"
                        : radios === "1"
                        ? currencyFormatDE((totalUbrano * 1000) / totalCokota) +
                          " kg"
                        : currencyFormatDE(totalUbrano / totalPovrsina) + " t"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                </template> -->
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex xs9 pa-2> </v-flex>
            <v-flex xs3 pa-2 style="text-align: right">
              *{{labFusnota}}
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialogNote_grafik"
      scrollable
      content-class="ModalInModalMaksimalaVelicinaBerbaNovo"
      persistent
    >
      <v-container style="padding: 0px; margin: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>
                {{ this.naslov_grafik_pom }}
              </div>

              <div style="text-align: right; margin-right: 95px">
                {{ this.ukupan_iznos }} RSD/kg
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModalGrafik"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <!-- <div data-v-fae5bece class="spacer"></div> -->
            <MyComponentGrafik
              :item="graphic_data_pom_novo"
              :naslov="naslov_grafik_pom"
              :vino="vino_pom"
            ></MyComponentGrafik>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";
import MyComponentGrafik from "../components/AmrChratPictorialStackedGrape.vue";

import html2pdf from "html2pdf.js";

import {
  readJSON,
  prevediOperacije3,
  prevediOperacije3SaSrpskog,
  getDateTime,
  daLiJeVinarija
} from "../helpers/Functions";
//import { valueToRelative } from "@amcharts/amcharts4/.internal/core/utils/Utils";

export default {
  props: ["operationType"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,
    MyComponentGrafik,
    Loading,
  },
  data() {
    return {
      json_fields: {
        Rb: "String",
        Datum: "Date",
        Količina: "String",
        "Grupa Količina": "String",
        Vinograd: "String",
        "Tip operacije": "String",
        Operacija: "String",
        Lot: "String",
        Cena: "Number",
        Iznos: "Number",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      isLoading: false,
      fullPage: true,

      headers_states: [],
      items_states: [],
      listSize: [5, 10, 25, 50, 100, { text: "Svi", value: 1000000 }],
      paginationKartica: {
        sortBy: "date",
        descending: true,
        rowsPerPage: 1000000,
        descending: true,
      },
      search: "",
      izabranaStranica: 0,
      operation_to_select: null,
      vineyard_items: [],
      vineyard_select: undefined,
      godina_items: [],
      godina_select: undefined,
      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateFormattedDo: null,

      loading: true,
      total: 0,
      totalTrajanje: 0,
      totalCokota: 0,
      totalPovrsina: 0,
      totalUbrano: 0,
      totalEksterniRadnici: 0,
      totalSopstveniRadnici: 0,
      totalEksterneMasine: 0,
      totalSopstveneMasine: 0,
      totalGoriva: 0,
      totalVoda: 0,
      selectedTab: 0,
      naziv_fajla: "",
      naslov: "",

      datumOdFiter: "",
      datumDoFiter: "",
      vinogradiFilter: "",
      fiterSorteGrozdja: "",

      grape_varietes_to_select: undefined,
      json_fields_type: [],

      grape_variety_select: null,
      grape_variety_items: [],
      vinery_block_select: undefined,

      radios: "0",
      godina: undefined,
      harvestYear: undefined,
      workforcePricePerH: undefined,
      mechanizationAmortizationAmount: undefined,
      waterPricePerM3: undefined,
      vineyardAmortizationAmount: undefined,
      otherCostsAmount: undefined,
      dialogNote_grafik: false,
      graphic_data_novo: [],
      graphic_data_pom_novo: [],
      vino_pom: false,
      naslov_grafik_pom: "",
      ukupan_iznos: "",

      zajednicki_objekat: undefined,
      izmena: false,
      vinarija: true,
      labPocokotu: "",
labVinograd: "",
labFusnota: "",
labBrojCokota: "",
labAmortVinograda: "",
labCenaGrozdja: "",
labNaslov1: "",
labNaslov2: "",
labNaslov3: "",
labNaslov4: "",
labNaslov5: "",
labNaslov6: "",
labNaslov7: ""
    };
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    params(nv) {
      return {
        ...this.paginationKartica,
        query: this.search,
      };
    },
  },
  watch: {
    operationType: function (val) {
      if (val !== null && val !== undefined) {
        this.selectedTab = 1;

        this.selectedTab = 0;

        if (this.selectedTab === 0) this.getAllKartice();
        else if (this.selectedTab === 1) this.getAllRadnici();
      }

      this.clear();
    },
    params: {
      handler(newVal, oldVal) {
        if (this.operationType !== undefined)
          if (
            (newVal.page !== oldVal.page ||
              newVal.rowsPerPage !== oldVal.rowsPerPage ||
              newVal.sortBy !== oldVal.sortBy ||
              newVal.descending !== oldVal.descending) &&
            newVal.sortBy !== ""
          ) {
            if (
              (newVal.sortBy === "date" && oldVal.sortBy === "plant_date") ||
              (newVal.sortBy === "plant_date" && oldVal.sortBy == "date")
            ) {
            } else {
              this.izabranaStranica = this.paginationKartica.page - 1;

              if (this.selectedTab === 0) this.getAllKartice();
              else if (this.selectedTab === 1) this.getAllRadnici();
            }
          }
      },
      deep: true,
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
  },

  methods: {
    vrati_style(kolona){
      // alert(kolona);

      if(kolona === this.labCenaGrozdja)
        return "padding-left: 5px; padding-right: 20px; overflow-wrap: break-word;"
      else
        return "padding-left: 5px; padding-right: 5px; overflow-wrap: break-word;"
    },
    sadIdeIzmena() {
      

      this.izmena = true;
    },
    submit_parameterGrafic(item) {
      this.naslov_grafik_pom = item.grapeVariety;

      this.graphic_data_novo = [
        {
          category: "Repromaterijal",
          value: item.material,
        },
        {
          category: "Radnici",
          value: item.internalWorkForce + item.externalWorkForce,
        },
        {
          category: "Mehanizacija",
          value: item.internalMechanization + item.externalMechanization,
        },
        {
          category: "Gorivo",
          value: item.fuel,
        },
        {
          category: "Voda",
          value: item.water,
        },
        {
          category: this.labAmortVinograda,
          value: item.vineyardAmortization,
        },
        {
          category: "Ostalo",
          value: item.otherCosts,
        },
      ];

      this.ukupan_iznos = this.currencyFormatDE(item.grapePricePerKg);

      this.dialogNote_grafik = true;
      this.graphic_data_pom_novo = this.graphic_data_novo;
    },
    submit_parameterGrafic2(item, item1) {
      this.naslov_grafik_pom = item1.grapeVariety  + " - " + item.vineyard;

      this.graphic_data_novo = [
        {
          category: "Repromaterijal",
          value: item.material,
        },
        // {
        //   category: "Filtriranja",
        //   value: response.data.filteringMaterialCost,
        // },
        {
          category: "Radnici",
          value: item.internalWorkForce + item.externalWorkForce,
        },
        {
          category: "Mehanizacija",
          value: item.internalMechanization + item.externalMechanization,
        },
        {
          category: "Gorivo",
          value: item.fuel,
        },
        {
          category: "Voda",
          value: item.water,
        },
        {
          category: "Amort. vinograda",
          value: item.vineyardAmortization,
        },
        {
          category: "Ostalo",
          value: item.otherCosts,
        },
      ];

      this.ukupan_iznos = this.currencyFormatDE(item.grapePricePerKg);

      this.dialogNote_grafik = true;
      this.graphic_data_pom_novo = this.graphic_data_novo;
    },
    closeModalGrafik() {
      this.dialogNote_grafik = false;
      this.graphic_data_pom_novo = undefined;
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.dateOd = [Year, Month, "01"].join("-");
      this.dateDo = [Year, Month, Day].join("-");
    },
    currencyFormatDE(num) {
      let odgovor = "";

      if (num !== undefined)
        odgovor = num
          .toFixed(2) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator

      return odgovor;
    },
    currencyFormat(num) {
      let odgovor = "";

      if (num !== undefined)
        odgovor = num
          .toFixed(0) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator

      return odgovor;
    },
    ekspandujRed(item) {
      if (item.item.value !== null) {
        item.expanded = !item.expanded;
      }
    },
    prevediOperacije3lok(text) {
      return prevediOperacije3(text);
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    convertMinToTime(locMinutes) {
      locMinutes = Math.round(locMinutes);

      var hour = Math.floor(locMinutes / 60);
      var minutes = locMinutes % 60;

      return (
        hour.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0")
      );
    },
    convertMinToTimeSaSekundama(locMinutes) {
      locMinutes = Math.round(locMinutes * 60);

      var hour = Math.floor(locMinutes / 3600);
      var minutes = Math.floor((locMinutes - hour * 3600) / 60);
      var secund = locMinutes % 60;

      return (
        minutes.toString().padStart(2, "0") +
        ":" +
        secund.toString().padStart(2, "0")
      );
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.selectedTab === 0) this.getAllKartice();
        else if (this.selectedTab === 1) this.getAllRadnici();
      }
    },
    submitIzmeniObracun() {
      if (this.$refs.form1.validate()) {
        this.vineyard_select = [];
        this.grape_variety_select = [];

        this.naziv_fajla = "utrosak_materijala.xls";

        this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Repromaterijal": "Number","Sopstveni radnici": "Number","Eksterni radnici": "Number","Sopstvene mašine": "Number","Eksterne mašine": "Number","Gorivo": "Number","Voda": "Number","' + this.labAmortVinograda + '": "Number", "Ostalo": "Number", "' + this.labCenaGrozdja + '": "Number"}');

        this.json_fields_type = [
          "String",
          "String",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
        ];

        let _this = this;

        this.changeSifarnik();
      }
    },
    getSifarnikDodajParametre() {
      if (this.$refs.form1.validate()) {
        this.isLoading = true;
      let _this = this;

      this.datumOdFiter = "";
      this.datumDoFiter = "";

      var pom_vineyard_to_select = "";
      this.vinogradiFilter = "";

      if (this.vineyard_select !== undefined && this.vineyard_select !== null) {
        this.vineyard_select.forEach(function (entry) {
          pom_vineyard_to_select =
            pom_vineyard_to_select + "vineyardId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_grape_variety_select = "";
      this.fiterSorteGrozdja = "";

      if (
        this.grape_variety_select !== undefined &&
        this.grape_variety_select !== null
      ) {
        this.grape_variety_select.forEach(function (entry) {
          pom_grape_variety_select =
            pom_grape_variety_select + "grapeVarietyId=" + entry.id + "&";

          _this.fiterSorteGrozdja = _this.fiterSorteGrozdja + entry.name + ", ";
        });
      }

      let urlLoc =
        "/vineyard_operation_execution/grape_price/" + this.godina_select + "?";

      if (pom_vineyard_to_select !== "")
        urlLoc = urlLoc + pom_vineyard_to_select + "&";

      if (pom_grape_variety_select !== "")
        urlLoc = urlLoc + pom_grape_variety_select + "&";

      urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      this.$http
        .get(this.globalServiceLocation + this.globalPort + urlLoc, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.items_states =
            response.data.grapeVarietyCalculatedCostsPerKgList;

          this.isLoading = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation + this.globalPort + urlLoc,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_states =
                        response.data.grapeVarietyCalculatedCostsPerKgList;

                      this.isLoading = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
      }
      
    },
    changeSifarnik() {
      this.isLoading = true;
      let _this = this;

      this.datumOdFiter = "";
      this.datumDoFiter = "";

      var pom_vineyard_to_select = "";
      this.vinogradiFilter = "";

      if (this.vineyard_select !== undefined && this.vineyard_select !== null) {
        this.vineyard_select.forEach(function (entry) {
          pom_vineyard_to_select =
            pom_vineyard_to_select + "vineyardId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_grape_variety_select = "";
      this.fiterSorteGrozdja = "";

      if (
        this.grape_variety_select !== undefined &&
        this.grape_variety_select !== null
      ) {
        this.grape_variety_select.forEach(function (entry) {
          pom_grape_variety_select =
            pom_grape_variety_select + "grapeVarietyId=" + entry.id + "&";

          _this.fiterSorteGrozdja = _this.fiterSorteGrozdja + entry.name + ", ";
        });
      }

      let urlLoc =
        "/vineyard_operation_execution/grape_price/" + this.godina_select + "?";

      if (pom_vineyard_to_select !== "")
        urlLoc = urlLoc + pom_vineyard_to_select + "&";

      if (pom_grape_variety_select !== "")
        urlLoc = urlLoc + pom_grape_variety_select + "&";

      urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      var complexObject = null;

      if (
        this.workforcePricePerH === undefined &&
        this.mechanizationAmortizationAmount === undefined &&
        this.waterPricePerM3 === undefined &&
        this.vineyardAmortizationAmount === undefined &&
        this.otherCostsAmount === undefined
      )
        complexObject = null;
      else
        complexObject = {
          harvestYear: this.godina,
          workforcePricePerH:
            this.workforcePricePerH === undefined
              ? null
              : this.workforcePricePerH,
          mechanizationAmortizationAmount:
            this.mechanizationAmortizationAmount === undefined
              ? null
              : this.mechanizationAmortizationAmount,
          waterPricePerM3:
            this.waterPricePerM3 === undefined ? null : this.waterPricePerM3,
          vineyardAmortizationAmount:
            this.vineyardAmortizationAmount === undefined
              ? null
              : this.vineyardAmortizationAmount,
          otherCostsAmount:
            this.otherCostsAmount === undefined ? null : this.otherCostsAmount,
        };

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + urlLoc,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          

          this.izmena = false;

          this.workforcePricePerH =
            response.data.calculationParameters.workforcePricePerH;
          this.mechanizationAmortizationAmount =
            response.data.calculationParameters.mechanizationAmortizationAmount;
          this.waterPricePerM3 =
            response.data.calculationParameters.waterPricePerM3;
          this.vineyardAmortizationAmount =
            response.data.calculationParameters.vineyardAmortizationAmount;
          this.otherCostsAmount =
            response.data.calculationParameters.otherCostsAmount;

          this.items_states =
            response.data.grapeVarietyCalculatedCostsPerKgList;

          this.graphic_data_novo = [
            {
              category: "Repromaterijal",
              value:
                response.data.addingMaterialCost +
                response.data.filteringMaterialCost +
                response.data.washingMaterialCost,
            },
            {
              category: "Grožđe",
              value: response.data.grapeCost,
            },
            {
              category: "Ambalaža",
              value: response.data.packagingCost,
            },
          ];

          this.isLoading = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + urlLoc,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.izmena = false;

                      this.workforcePricePerH =
                        response.data.calculationParameters.workforcePricePerH;
                      this.mechanizationAmortizationAmount =
                        response.data.calculationParameters.mechanizationAmortizationAmount;
                      this.waterPricePerM3 =
                        response.data.calculationParameters.waterPricePerM3;
                      this.vineyardAmortizationAmount =
                        response.data.calculationParameters.vineyardAmortizationAmount;
                      this.otherCostsAmount =
                        response.data.calculationParameters.otherCostsAmount;

                      this.items_states =
                        response.data.grapeVarietyCalculatedCostsPerKgList;

                      this.isLoading = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getSifarnik() {
      this.izmena = false;

      if (this.godina_select !== undefined && this.godina_select !== null) {
        this.isLoading = true;

        let urlLoc =
          "/vineyard_operation_execution/grape_price/" + this.godina_select;

        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlLoc, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.resetujSveOstalo();

            if (response.data.calculationParameters !== null) {
              this.workforcePricePerH =
                response.data.calculationParameters.workforcePricePerH;
              this.mechanizationAmortizationAmount =
                response.data.calculationParameters.mechanizationAmortizationAmount;
              this.waterPricePerM3 =
                response.data.calculationParameters.waterPricePerM3;
              this.vineyardAmortizationAmount =
                response.data.calculationParameters.vineyardAmortizationAmount;
              this.otherCostsAmount =
                response.data.calculationParameters.otherCostsAmount;

              this.zajednicki_objekat = {
                workforcePricePerH:
                  response.data.calculationParameters.workforcePricePerH,
                mechanizationAmortizationAmount:
                  response.data.calculationParameters
                    .mechanizationAmortizationAmount,
                waterPricePerM3:
                  response.data.calculationParameters.waterPricePerM3,
                vineyardAmortizationAmount:
                  response.data.calculationParameters
                    .vineyardAmortizationAmount,
                otherCostsAmount:
                  response.data.calculationParameters.otherCostsAmount,
              };
            } else
              this.zajednicki_objekat = {
                workforcePricePerH: null,
                mechanizationAmortizationAmount: null,
                waterPricePerM3: null,
                vineyardAmortizationAmount: null,
                otherCostsAmount: null,
              };
            this.items_states =
              response.data.grapeVarietyCalculatedCostsPerKgList;

            this.graphic_data_novo = [
              {
                category: "Repromaterijal",
                value:
                  response.data.addingMaterialCost +
                  response.data.filteringMaterialCost +
                  response.data.washingMaterialCost,
              },
              {
                category: "Grožđe",
                value: response.data.grapeCost,
              },
              {
                category: "Ambalaža",
                value: response.data.packagingCost,
              },
            ];

            this.isLoading = false;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation + this.globalPort + urlLoc,
                        complexObject,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.resetujSveOstalo();

                        if (response.data.calculationParameters !== null) {
                          this.workforcePricePerH =
                            response.data.calculationParameters.workforcePricePerH;
                          this.mechanizationAmortizationAmount =
                            response.data.calculationParameters.mechanizationAmortizationAmount;
                          this.waterPricePerM3 =
                            response.data.calculationParameters.waterPricePerM3;
                          this.vineyardAmortizationAmount =
                            response.data.calculationParameters.vineyardAmortizationAmount;
                          this.otherCostsAmount =
                            response.data.calculationParameters.otherCostsAmount;

                          this.zajednicki_objekat = {
                            workforcePricePerH:
                              response.data.calculationParameters
                                .workforcePricePerH,
                            mechanizationAmortizationAmount:
                              response.data.calculationParameters
                                .mechanizationAmortizationAmount,
                            waterPricePerM3:
                              response.data.calculationParameters
                                .waterPricePerM3,
                            vineyardAmortizationAmount:
                              response.data.calculationParameters
                                .vineyardAmortizationAmount,
                            otherCostsAmount:
                              response.data.calculationParameters
                                .otherCostsAmount,
                          };
                        } else
                          this.zajednicki_objekat = {
                            workforcePricePerH: null,
                            mechanizationAmortizationAmount: null,
                            waterPricePerM3: null,
                            vineyardAmortizationAmount: null,
                            otherCostsAmount: null,
                          };

                        this.items_states =
                          response.data.grapeVarietyCalculatedCostsPerKgList;

                        this.graphic_data_novo = [
                          {
                            category: "Repromaterijal",
                            value:
                              response.data.addingMaterialCost +
                              response.data.filteringMaterialCost +
                              response.data.washingMaterialCost,
                          },
                          {
                            category: "Grožđe",
                            value: response.data.grapeCost,
                          },
                          {
                            category: "Ambalaža",
                            value: response.data.packagingCost,
                          },
                        ];

                        this.isLoading = false;
                      })
                      .catch((e) => {
                        this.isLoading = false;

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },

    submitVrednosti() {
      this.radios = "0"

      this.clear_init();

      this.headers_states = [
        { text: "Rb.", value: "", align: "center", sortable: false },
        {
          text: "Sorta/" + this.labVinograd,
          value: "grapeVariety",
          align: "center",
          sortable: true,
        },
        {
          text: this.labBrojCokota,
          value: "numberOfPlants",
          align: "right",
          sortable: true,
        },
        {
          text: "Površina",
          value: "surface",
          align: "right",
          sortable: true,
        },
        {
          text: "Količina",
          value: "harvestQuantityInT",
          align: "right",
          sortable: true,
        },
      ];

      this.paginationKartica = {
        sortBy: "date",
        descending: true,
        rowsPerPage: 1000000,
        descending: true,
        page: 1,
      };

      this.items_states = [];

      this.total = 0;
      this.totalUbrano = 0;
      this.totalCokota = 0;
      this.totalPovrsina = 0;
      this.totalSopstveniRadnici = 0;
      this.totalEksterniRadnici = 0;
      this.totalEksterneMasine = 0;
      this.totalSopstveneMasine = 0;
      this.totalGoriva = 0;
      this.totalVoda = 0;

      this.json_data = [];
    },
    submitKolicine() {
      this.radios = "0"
      this.clear_init();

      if (this.radios === "0")
        this.headers_states = [
          { text: "Rb.", value: "", align: "center", sortable: false },
          {
            text: "Sorta/" + this.labVinograd,
            value: "grapeVariety",
            align: "center",
            sortable: true,
          },
          {
            text: this.labBrojCokota,
            value: "numberOfPlants",
            align: "right",
            sortable: true,
          },
          {
            text: "Površina",
            value: "surface",
            align: "right",
            sortable: true,
          },
          {
            text: "Ubrano",
            value: "harvestQuantityInT",
            align: "right",
            sortable: true,
          },
          {
            text: "Repromaterijal",
            value: "materialCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterne mašine",
            value: "externalMechanizationCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterni radnici",
            value: "externalWorkForceCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Gorivo",
            value: "fuelConsumption",
            align: "right",
            sortable: true,
          },
          {
            text: "Ukupno",
            value: "",
            align: "right",
            sortable: false,
          },
        ];
      else
        this.headers_states = [
          { text: "Rb.", value: "", align: "center", sortable: false },
          {
            text: "Sorta/" + this.labVinograd,
            value: "grapeVariety",
            align: "center",
            sortable: true,
          },
          {
            text: this.labBrojCokota,
            value: "numberOfPlants",
            align: "right",
            sortable: true,
          },
          {
            text: "Površina",
            value: "surface",
            align: "right",
            sortable: true,
          },
          {
            text: "Ubrano",
            value: "harvestQuantityInT",
            align: "right",
            sortable: true,
          },
          {
            text: "Sopstvene mašine",
            value: "interanlMechanizationHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterne mašine",
            value: "exteranlMechanizationHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Sopstveni radnici",
            value: "interanlWorkForceHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterni radnici",
            value: "exteranlWorkForceHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Gorivo",
            value: "fuelConsumption",
            align: "right",
            sortable: true,
          },
          {
            text: "Voda",
            value: "waterConsumption",
            align: "right",
            sortable: true,
          },
        ];

      this.items_states = [];

      this.total = 0;
      this.totalUbrano = 0;
      this.totalCokota = 0;
      this.totalPovrsina = 0;
      this.totalSopstveniRadnici = 0;
      this.totalEksterniRadnici = 0;
      this.totalEksterneMasine = 0;
      this.totalSopstveneMasine = 0;
      this.totalGoriva = 0;
      this.totalVoda = 0;

      this.json_data = [];
    },
    clear_init(){
      this.resetujSveOstalo();
      
      this.godina_select = undefined;

      if(this.$refs.element11 !== undefined)
        this.$refs.element11.reset();

        this.godina_select = undefined;
    },
    submitObracun() {
      this.clear();
      this.clear_init();

      this.items_states = [];

      this.json_data = [];

      this.headers_states = [
        { text: "Rb.", value: "", align: "center", sortable: false },
        {
          text: "Sorta/" + this.labVinograd,
          value: "grapeVariety",
          align: "center",
          sortable: true,
        },
        {
          text: this.labBrojCokota,
          value: "numberOfPlants",
          align: "right",
          sortable: true,
        },
        {
          text: "Površina",
          value: "surface",
          align: "right",
          sortable: true,
        },
        {
          text: "Ubrano",
          value: "harvestQuantityInT",
          align: "right",
          sortable: true,
        },
        {
          text: "Repromaterijal",
          value: "material",
          align: "right",
          sortable: true,
        },
        {
          text: "Sopst. radnici",
          value: "internalWorkForce",
          align: "right",
          sortable: true,
        },
        {
          text: "Ekster. radnici",
          value: "externalWorkForce",
          align: "right",
          sortable: true,
        },
        {
          text: "Sopst. mašine",
          value: "internalMechanization",
          align: "right",
          sortable: true,
        },
        {
          text: "Ekster. mašine",
          value: "externalMechanization",
          align: "right",
          sortable: true,
        },
        {
          text: "Gorivo",
          value: "fuel",
          align: "right",
          sortable: true,
        },
        {
          text: "Voda",
          value: "water",
          align: "right",
          sortable: true,
        },
        {
          text: "Amor. vinograda",
          value: "vineyardAmortization",
          align: "right",
          sortable: true,
        },
        {
          text: "Ostalo",
          value: "otherCosts",
          align: "right",
          sortable: false,
        },
        {
          text: this.labCenaGrozdja,
          value: "grapePricePerKg",
          align: "right",
          sortable: false,
        },
        {
          text: "",
          value: "",
          sortable: false,
        },
      ];


      let bool = true;

      

    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getFieldTextMechanization(item) {
      return `${item.name} (${item.type})`;
    },
    getVineYards() {
      let url = "";

      url = this.globalServiceLocation + this.globalPort + "/vineyard/all";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.vineyard_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.vineyard_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getYears() {
      let url = "";

      url =
        this.globalServiceLocation +
        this.globalPort +
        "/vineyard_operation_execution/grape_harvest_years";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          

        this.godina_items = response.data;

        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.godina_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getGrapeVarieties() {
      let url = "";

      url = this.globalServiceLocation + this.globalPort + "/grape_variety/all";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.grape_variety_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.grape_variety_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetujSveOstalo() {
      this.workforcePricePerH = undefined;
      this.mechanizationAmortizationAmount = undefined;
      this.waterPricePerM3 = undefined;
      this.vineyardAmortizationAmount = undefined;
      this.otherCostsAmount = undefined;

      this.vineyard_select = [];
      this.grape_variety_select = [];

      this.zajednicki_objekat = undefined;
    },
    preracunajVrednostiZaStampu() {
      if (this.selectedTab == 0) {
        this.naslov =
          this.radios === "0"
            ? this.labNaslov1
            : this.radios === "1"
            ? this.labNaslov2
            : this.labNaslov3;

        this.total = 0;
        this.totalUbrano = 0;
        this.totalCokota = 0;
        this.totalPovrsina = 0;
        this.totalSopstveniRadnici = 0;
        this.totalEksterniRadnici = 0;
        this.totalEksterneMasine = 0;
        this.totalSopstveneMasine = 0;
        this.totalGoriva = 0;
        this.totalVoda = 0;

        let _this = this;
        this.json_data = [];

        let rbr = 0;

        this.items_states.forEach(function (entry) {
          rbr = rbr + 1;

          _this.total = _this.total + entry.harvestQuantityInT;
          _this.totalCokota = _this.totalCokota + entry.numberOfPlants;
          _this.totalPovrsina = _this.totalPovrsina + entry.surface;
          _this.totalUbrano = _this.totalUbrano + entry.harvestQuantityInT;

          let objekat = {
            Rb: rbr,
            "Sorta/Vinograd": entry.grapeVariety,
            "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
            Površina: _this.currencyFormatDE(entry.surface),
            Količina:
              _this.radios === "0"
                ? _this.currencyFormatDE(entry.harvestQuantityInT)
                : _this.radios === "1"
                ? _this.currencyFormatDE(
                    entry.numberOfPlants !== 0
                      ? (entry.harvestQuantityInT * 1000) / entry.numberOfPlants
                      : 0
                  )
                : _this.currencyFormatDE(
                    entry.surface !== 0
                      ? entry.harvestQuantityInT / entry.surface
                      : 0
                  ),
          };

          _this.json_data.push(objekat);

          entry.vineyardDataDtos.forEach(function (entry1) {
            let objekat1 = {
              Rb: "",
              "Sorta/Vinograd": entry1.vineyard,
              "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
              Površina: _this.currencyFormatDE(entry1.surfaceInHa),
              Količina:
                _this.radios === "0"
                  ? _this.currencyFormatDE(entry1.harvestQuantityInT)
                  : _this.radios === "1"
                  ? _this.currencyFormatDE(
                      entry1.numberOfPlants !== 0
                        ? (entry1.harvestQuantityInT * 1000) /
                            entry1.numberOfPlants
                        : 0
                    )
                  : _this.currencyFormatDE(
                      entry1.surfaceInHa !== 0
                        ? entry1.harvestQuantityInT / entry1.surfaceInHa
                        : 0
                    ),
            };

            _this.json_data.push(objekat1);
          });
        });

        let objekat = {
          Rb: "",
          "Sorta/Vinograd": "Ukupna vrednost:",
          "Broj čokota": this.currencyFormat(this.totalCokota),
          Površina: this.currencyFormatDE(this.totalPovrsina),
          Količina:
            _this.radios === "0"
              ? this.currencyFormatDE(this.totalUbrano)
              : _this.radios === "1"
              ? this.currencyFormatDE(
                  (this.totalUbrano * 1000) / this.totalCokota
                )
              : this.currencyFormatDE(this.totalUbrano / this.totalPovrsina),
        };

        this.json_data.push(objekat);
      } else if (this.selectedTab === 1) {
        if (this.radios === "0") {
          this.headers_states = [
            { text: "Rb.", value: "", align: "center", sortable: false },
            {
              text: "Sorta/" + this.labVinograd,
              value: "grapeVariety",
              align: "center",
              sortable: true,
            },
            {
              text: this.labBrojCokota,
              value: "numberOfPlants",
              align: "right",
              sortable: true,
            },
            {
              text: "Površina",
              value: "surface",
              align: "right",
              sortable: true,
            },
            {
              text: "Ubrano",
              value: "harvestQuantityInT",
              align: "right",
              sortable: true,
            },
            {
              text: "Repromaterijal",
              value: "materialCosts",
              align: "right",
              sortable: true,
            },
            {
              text: "Eksterne mašine",
              value: "externalMechanizationCosts",
              align: "right",
              sortable: true,
            },
            {
              text: "Eksterni radnici",
              value: "externalWorkForceCosts",
              align: "right",
              sortable: true,
            },
            {
              text: "Gorivo",
              value: "fuelConsumption",
              align: "right",
              sortable: true,
            },
            {
              text: "Ukupno",
              value: "",
              align: "right",
              sortable: false,
            },
          ];

          this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Repromaterijal": "Number","Eksterne mašine": "Number","Eksterni radnici": "Number","Gorivo": "Number","Ukupno": "Number"}');
        } else {
          this.headers_states = [
            { text: "Rb.", value: "", align: "center", sortable: false },
            {
              text: "Sorta/" + this.labVinograd,
              value: "grapeVariety",
              align: "center",
              sortable: true,
            },
            {
              text: this.labBrojCokota,
              value: "numberOfPlants",
              align: "right",
              sortable: true,
            },
            {
              text: "Površina",
              value: "surface",
              align: "right",
              sortable: true,
            },
            {
              text: "Ubrano",
              value: "harvestQuantityInT",
              align: "right",
              sortable: true,
            },
            {
              text: "Sopstvene mašine",
              value: "interanlMechanizationHours",
              align: "right",
              sortable: true,
            },
            {
              text: "Eksterne mašine",
              value: "exteranlMechanizationHours",
              align: "right",
              sortable: true,
            },
            {
              text: "Sopstveni radnici",
              value: "interanlWorkForceHours",
              align: "right",
              sortable: true,
            },
            {
              text: "Eksterni radnici",
              value: "exteranlWorkForceHours",
              align: "right",
              sortable: true,
            },
            {
              text: "Gorivo",
              value: "fuelConsumption",
              align: "right",
              sortable: true,
            },
            {
              text: "Voda",
              value: "waterConsumption",
              align: "right",
              sortable: true,
            },
          ];

          this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Sopstvene mašine": "Number","Eksterne mašine": "Number","Sopstveni radnici": "Number","Eksterni radnici": "Number","Gorivo": "Number","Voda": "Number"}');
        }

        this.naslov =
          this.radios === "0"
            ? this.labNaslov5 
            : this.labNaslov6;

        this.total = 0;
        this.totalUbrano = 0;
        this.totalCokota = 0;
        this.totalPovrsina = 0;
        this.totalSopstveniRadnici = 0;
        this.totalEksterniRadnici = 0;
        this.totalEksterneMasine = 0;
        this.totalSopstveneMasine = 0;
        this.totalGoriva = 0;
        this.totalVoda = 0;

        let _this = this;
        this.json_data = [];

        let rbr = 0;

        this.items_states.forEach(function (entry) {
          rbr = rbr + 1;

          _this.total = _this.total + entry.harvestQuantityInT;

          _this.totalCokota = _this.totalCokota + entry.numberOfPlants;
          _this.totalPovrsina = _this.totalPovrsina + entry.surface;

          _this.totalUbrano = _this.totalUbrano + entry.harvestQuantityInT;
          _this.totalSopstveneMasine =
            _this.totalSopstveneMasine +
            (_this.radios === "0"
              ? entry.materialCosts
              : entry.interanlMechanizationHours);
          _this.totalSopstveniRadnici =
            _this.totalSopstveniRadnici +
            (_this.radios === "0" ? 0 : entry.interanlWorkForceHours);
          _this.totalEksterneMasine =
            _this.totalEksterneMasine +
            (_this.radios === "0"
              ? entry.externalMechanizationCosts
              : entry.exteranlMechanizationHours);

          _this.totalEksterniRadnici =
            _this.totalEksterniRadnici +
            (_this.radios === "0"
              ? entry.externalWorkForceCosts
              : entry.exteranlWorkForceHours);
          _this.totalGoriva =
            _this.totalGoriva +
            (_this.radios === "0" ? entry.fuelCosts : entry.fuelConsumption);
          _this.totalVoda = _this.totalVoda + entry.waterConsumption;

          let objekat;
          if (_this.radios === "0")
            objekat = {
              Rb: rbr,
              "Sorta/Vinograd": entry.grapeVariety,
              "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
              Površina: _this.currencyFormatDE(entry.surface),
              Ubrano: _this.currencyFormatDE(entry.harvestQuantityInT),
              Repromaterijal: _this.currencyFormatDE(
                entry.harvestQuantityInT !== 0
                  ? entry.materialCosts / entry.harvestQuantityInT
                  : 0
              ),
              "Eksterne mašine":
                _this.radios === "0"
                  ? _this.currencyFormatDE(
                      entry.externalMechanizationCosts /
                        entry.harvestQuantityInT
                    )
                  : _this.convertMinToTime(
                      entry.harvestQuantityInT !== 0
                        ? entry.exteranlMechanizationHours /
                            entry.harvestQuantityInT
                        : 0
                    ),
              "Eksterni radnici":
                _this.radios === "0"
                  ? _this.currencyFormatDE(
                      entry.externalWorkForceCosts / entry.harvestQuantityInT
                    )
                  : _this.convertMinToTime(
                      entry.harvestQuantityInT !== 0
                        ? entry.exteranlWorkForceHours /
                            entry.harvestQuantityInT
                        : 0
                    ),
              Gorivo:
                _this.radios === "0"
                  ? _this.currencyFormatDE(
                      entry.fuelCosts / entry.harvestQuantityInT
                    )
                  : _this.currencyFormatDE(
                      entry.harvestQuantityInT !== 0
                        ? entry.fuelConsumption / entry.harvestQuantityInT
                        : 0
                    ),
              Ukupno: _this.currencyFormatDE(
                (entry.materialCosts +
                  entry.externalMechanizationCosts +
                  entry.externalWorkForceCosts +
                  entry.fuelCosts) /
                  entry.harvestQuantityInT
              ),
            };
          else
            objekat = {
              Rb: rbr,
              "Sorta/Vinograd": entry.grapeVariety,
              "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
              Površina: _this.currencyFormatDE(entry.surface),
              Ubrano: _this.currencyFormatDE(entry.harvestQuantityInT),
              "Sopstvene mašine": _this.convertMinToTime(
                entry.harvestQuantityInT !== 0
                  ? entry.interanlMechanizationHours / entry.harvestQuantityInT
                  : 0
              ),
              "Eksterne mašine": _this.convertMinToTime(
                entry.harvestQuantityInT !== 0
                  ? entry.exteranlMechanizationHours / entry.harvestQuantityInT
                  : 0
              ),
              "Sopstveni radnici": _this.convertMinToTime(
                entry.harvestQuantityInT !== 0
                  ? entry.interanlWorkForceHours / entry.harvestQuantityInT
                  : 0
              ),
              "Eksterni radnici": _this.convertMinToTime(
                entry.harvestQuantityInT !== 0
                  ? entry.exteranlWorkForceHours / entry.harvestQuantityInT
                  : 0
              ),
              Gorivo: _this.currencyFormatDE(
                entry.harvestQuantityInT !== 0
                  ? entry.fuelConsumption / entry.harvestQuantityInT
                  : 0
              ),
              Voda: _this.currencyFormatDE(
                entry.harvestQuantityInT !== 0
                  ? entry.waterConsumption / entry.harvestQuantityInT
                  : 0
              ),
            };

          _this.json_data.push(objekat);

          entry.vineyardPerGrapeVarietyData.forEach(function (entry1) {
            let objekat1;

            if (_this.radios === "0")
              objekat1 = {
                Rb: "",
                "Sorta/Vinograd": entry1.vineyard,
                "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
                Površina: _this.currencyFormatDE(entry1.surfaceInHa),
                Ubrano: _this.currencyFormatDE(entry1.harvestQuantityInT),
                Repromaterijal: _this.currencyFormatDE(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.materialCosts / entry1.harvestQuantityInT
                    : 0
                ),
                "Eksterne mašine": _this.currencyFormatDE(
                  entry1.externalMechanizationCosts / entry1.harvestQuantityInT
                ),
                "Eksterni radnici": _this.currencyFormatDE(
                  entry1.externalWorkForceCosts / entry1.harvestQuantityInT
                ),
                Gorivo: _this.currencyFormatDE(
                  entry1.fuelCosts / entry1.harvestQuantityInT
                ),
                Total: _this.currencyFormatDE(
                  entry1.harvestQuantityInT !== 0
                    ? (entry1.materialCosts +
                        entry1.externalMechanizationCosts +
                        entry1.externalWorkForceCosts +
                        entry1.fuelCosts) /
                        entry1.harvestQuantityInT
                    : 0
                ),
              };
            else
              objekat1 = {
                Rb: "",
                "Sorta/Vinograd": entry1.vineyard,
                "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
                Površina: _this.currencyFormatDE(entry1.surfaceInHa),
                Ubrano: _this.currencyFormatDE(entry1.harvestQuantityInT),
                "Sopstvene mašine": _this.convertMinToTime(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.interanlMechanizationHours /
                        entry1.harvestQuantityInT
                    : 0
                ),
                "Eksterne mašine": _this.convertMinToTime(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.exteranlMechanizationHours /
                        entry1.harvestQuantityInT
                    : 0
                ),
                "Sopstveni radnici": _this.convertMinToTime(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.interanlWorkForceHours / entry1.harvestQuantityInT
                    : 0
                ),
                "Eksterni radnici": _this.convertMinToTime(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.exteranlWorkForceHours / entry1.harvestQuantityInT
                    : 0
                ),
                Gorivo: _this.currencyFormatDE(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.fuelConsumption / entry1.harvestQuantityInT
                    : 0
                ),
                Voda: _this.currencyFormatDE(
                  entry1.harvestQuantityInT !== 0
                    ? entry1.waterConsumption / entry1.harvestQuantityInT
                    : 0
                ),
              };

            _this.json_data.push(objekat1);
          });
        });

        let objekat;

        if (this.radios === "0")
          objekat = {
            Rb: "",
            "Sorta/Vinograd": "Ukupna vrednost:",
            "Broj čokota": this.currencyFormat(this.totalCokota),
            Površina: this.currencyFormatDE(this.totalPovrsina),
            Ubrano: this.currencyFormatDE(this.totalUbrano),
            Repromaterijal: this.currencyFormatDE(
              this.totalSopstveneMasine / this.totalUbrano
            ),
            "Eksterne mašine": this.currencyFormatDE(
              this.totalEksterneMasine / this.totalUbrano
            ),
            "Eksterni radnici": this.currencyFormatDE(
              this.totalEksterniRadnici / this.totalUbrano
            ),
            Gorivo: this.currencyFormatDE(this.totalGoriva / this.totalUbrano),
            Ukupno: this.currencyFormatDE(
              (this.totalSopstveneMasine +
                this.totalEksterneMasine +
                this.totalEksterniRadnici +
                this.totalGoriva) /
                this.totalUbrano
            ),
          };
        else
          objekat = {
            Rb: "",
            "Sorta/Vinograd": "Ukupna vrednost:",
            "Broj čokota": this.currencyFormat(this.totalCokota),
            Površina: this.currencyFormatDE(this.totalPovrsina),
            Ubrano: this.currencyFormatDE(this.totalUbrano),
            "Sopstvene mašine": this.convertMinToTime(
              this.totalSopstveneMasine / this.totalUbrano
            ),
            "Eksterne mašine": this.convertMinToTime(
              this.totalEksterneMasine / this.totalUbrano
            ),
            "Sopstveni radnici": this.convertMinToTime(
              this.totalSopstveniRadnici / this.totalUbrano
            ),
            "Eksterni radnici": this.convertMinToTime(
              this.totalEksterniRadnici / this.totalUbrano
            ),
            Gorivo: this.currencyFormatDE(this.totalGoriva / this.totalUbrano),
            Voda: this.currencyFormatDE(this.totalVoda / this.totalUbrano),
          };
        this.json_data.push(objekat);
      } else {

        this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Repromaterijal": "Number","Sopstveni radnici": "Number","Eksterni radnici": "Number","Sopstvene mašine": "Number","Eksterne mašine": "Number","Gorivo": "Number","Voda": "Number","' + this.labAmortVinograda + '": "Number", "Ostalo": "Number", "' + this.labCenaGrozdja + '": "Number"}');

        this.naslov = 
        this.labNaslov7 +
          this.godina_select +
          ". godinu";

        this.total = 0;
        this.totalUbrano = 0;
        this.totalCokota = 0;
        this.totalPovrsina = 0;
        this.totalSopstveniRadnici = 0;
        this.totalEksterniRadnici = 0;
        this.totalEksterneMasine = 0;
        this.totalSopstveneMasine = 0;
        this.totalGoriva = 0;
        this.totalVoda = 0;

        // this.totalMaterijal = 0;
        // this.totalAmortizacijaVinograda = 0;
        // this.totalOstalo = 0;

        let _this = this;
        this.json_data = [];

        let rbr = 0;

        this.items_states.forEach(function (entry) {
          rbr = rbr + 1;

          // _this.total = _this.total + entry.harvestQuantityInT;
          // _this.totalCokota = _this.totalCokota + entry.numberOfPlants;
          // _this.totalPovrsina = _this.totalPovrsina + entry.surface;
          // _this.totalUbrano = _this.totalUbrano + entry.harvestQuantityInT;

          let objekat = {
            Rb: rbr,
            "Sorta/Vinograd": entry.grapeVariety,
            "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
            Površina: _this.currencyFormatDE(entry.surface),
            Ubrano: _this.currencyFormatDE(entry.harvestQuantityInT),
            Repromaterijal: _this.currencyFormatDE(entry.material),
            "Sopstveni radnici": _this.currencyFormatDE(
              entry.internalWorkForce
            ),
            "Eksterni radnici": _this.currencyFormatDE(entry.externalWorkForce),
            "Sopstvene mašine": _this.currencyFormatDE(
              entry.internalMechanization
            ),
            "Eksterne mašine": _this.currencyFormatDE(
              entry.externalMechanization
            ),
            Gorivo: _this.currencyFormatDE(entry.fuel),
            Voda: _this.currencyFormatDE(entry.water),
            "Amort. vinograda": _this.currencyFormatDE(
              entry.vineyardAmortization
            ),
            Ostalo: _this.currencyFormatDE(entry.otherCosts),
            "Cena grožđa": _this.currencyFormatDE(entry.grapePricePerKg),
          };

          _this.json_data.push(objekat);

          entry.vineyardPerGrapeVarietyData.forEach(function (entry1) {
            let objekat1 = {
              Rb: "",
              "Sorta/Vinograd": entry1.vineyard,
              "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
              Površina: _this.currencyFormatDE(entry1.surfaceInHa),
              Ubrano: _this.currencyFormatDE(entry1.harvestQuantityInT),
              Repromaterijal: _this.currencyFormatDE(entry1.material),
              "Sopstveni radnici": _this.currencyFormatDE(
                entry1.internalWorkForce
              ),
              "Eksterni radnici": _this.currencyFormatDE(
                entry1.externalWorkForce
              ),
              "Sopstvene mašine": _this.currencyFormatDE(
                entry1.internalMechanization
              ),
              "Eksterne mašine": _this.currencyFormatDE(
                entry1.externalMechanization
              ),
              Gorivo: _this.currencyFormatDE(entry1.fuel),
              Voda: _this.currencyFormatDE(entry1.water),
              "Amort. vinograda": _this.currencyFormatDE(
                entry1.vineyardAmortization
              ),
              Ostalo: _this.currencyFormatDE(entry1.otherCosts),
              "Cena grožđa": _this.currencyFormatDE(entry1.grapePricePerKg),
            };

            _this.json_data.push(objekat1);
          });
        });

        // let objekat = {
        //   Rb: "",
        //   "Sorta/Vinograd": "Ukupna vrednost:",
        //   "Broj čokota": this.currencyFormat(this.totalCokota),
        //   Površina: this.currencyFormatDE(this.totalPovrsina),
        //   Količina:
        //     _this.radios === "0"
        //       ? this.currencyFormatDE(this.totalUbrano)
        //       : _this.radios === "1"
        //       ? this.currencyFormatDE(
        //           (this.totalUbrano * 1000) / this.totalCokota
        //         )
        //       : this.currencyFormatDE(this.totalUbrano / this.totalPovrsina),
        // };

        // this.json_data.push(objekat);
      }
    },
    getAllKartice() {
      this.isLoading = true;

      this.naziv_fajla = "utrosak_materijala.xls";
      this.naslov = "Utrošci u vinogradu po sorti grožđa";

      this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Količina": "Number"}');

      this.json_fields_type = [
        "String",
        "String",
        "Number",
        "Number",
        "Number",
      ];

      this.headers_states = [
        { text: "Rb.", value: "", align: "center", sortable: false },
        {
          text: "Sorta/" + this.labVinograd,
          value: "grapeVariety",
          align: "center",
          sortable: true,
        },
        {
          text: this.labBrojCokota,
          value: "numberOfPlants",
          align: "right",
          sortable: true,
        },
        {
          text: "Površina",
          value: "surface",
          align: "right",
          sortable: true,
        },
        {
          text: "Količina",
          value: "harvestQuantityInT",
          align: "right",
          sortable: true,
        },
      ];

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_vineyard_to_select = "";

      this.vinogradiFilter = "";

      if (this.vineyard_select !== undefined && this.vineyard_select !== null) {
        this.vineyard_select.forEach(function (entry) {
          pom_vineyard_to_select =
            pom_vineyard_to_select + "vineyardId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_grape_variety_select = "";
      this.fiterSorteGrozdja = "";

      if (
        this.grape_variety_select !== undefined &&
        this.grape_variety_select !== null
      ) {
        this.grape_variety_select.forEach(function (entry) {
          pom_grape_variety_select =
            pom_grape_variety_select + "grapeVarietyId=" + entry.id + "&";

          _this.fiterSorteGrozdja = _this.fiterSorteGrozdja + entry.name + ", ";
        });
      }

      let urlLoc =
        "/vineyard_operation_execution/grape_harvested_per_unit?" +
        pom_vineyard_to_select +
        pom_grape_variety_select;

      // if (
      //   urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
      //   urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      // )
      //   urlLoc = urlLoc + sortiranje;
      // else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      setTimeout(() => {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              urlLoc +
              strDate +
              strDateDo,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.total = 0;
            this.totalUbrano = 0;
            this.totalCokota = 0;
            this.totalPovrsina = 0;
            this.totalSopstveniRadnici = 0;
            this.totalEksterniRadnici = 0;
            this.totalEksterneMasine = 0;
            this.totalSopstveneMasine = 0;
            this.totalGoriva = 0;
            this.totalVoda = 0;

            this.items_states = response.data;

            let _this = this;
            this.json_data = [];

            let rbr = 0;

            response.data.forEach(function (entry) {
              rbr = rbr + 1;

              _this.total = _this.total + entry.harvestQuantityInT;
              _this.totalCokota = _this.totalCokota + entry.numberOfPlants;
              _this.totalPovrsina = _this.totalPovrsina + entry.surface;
              _this.totalUbrano = _this.totalUbrano + entry.harvestQuantityInT;

              let objekat = {
                Rb: rbr,
                "Sorta/Vinograd": entry.grapeVariety,
                "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
                Površina: _this.currencyFormatDE(entry.surface),
                Količina: _this.currencyFormatDE(entry.harvestQuantityInT),
              };

              _this.json_data.push(objekat);

              entry.vineyardDataDtos.forEach(function (entry1) {
                let objekat1 = {
                  Rb: "",
                  "Sorta/Vinograd": entry1.grapeVariety,
                  "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
                  Površina: _this.currencyFormatDE(entry1.surface),
                  Količina: _this.currencyFormatDE(entry1.harvestQuantityInT),
                };

                _this.json_data.push(objekat1);
              });
            });

            let objekat = {
              Rb: "",
              "Sorta/Vinograd": "Ukupna vrednost:",
              "Broj čokota": this.currencyFormat(this.totalCokota),
              Površina: this.currencyFormatDE(this.totalPovrsina),
              Količina: this.currencyFormatDE(this.totalUbrano),
            };

            this.json_data.push(objekat);

            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlLoc +
                          strDate +
                          strDateDo +
                          "&page=" +
                          this.izabranaStranica +
                          "&offset=" +
                          this.paginationKartica.rowsPerPage,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.total = 0;
                        this.totalUbrano = 0;
                        this.totalCokota = 0;
                        this.totalPovrsina = 0;
                        this.totalSopstveniRadnici = 0;
                        this.totalEksterniRadnici = 0;
                        this.totalEksterneMasine = 0;
                        this.totalSopstveneMasine = 0;
                        this.totalGoriva = 0;
                        this.totalVoda = 0;

                        this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];

                        let rbr = 0;

                        response.data.forEach(function (entry) {
                          rbr = rbr + 1;

                          _this.total = _this.total + entry.harvestQuantityInT;
                          _this.totalCokota =
                            _this.totalCokota + entry.numberOfPlants;
                          _this.totalPovrsina =
                            _this.totalPovrsina + entry.surface;
                          _this.totalUbrano =
                            _this.totalUbrano + entry.harvestQuantityInT;

                          let objekat = {
                            Rb: rbr,
                            "Sorta/Vinograd": entry.grapeVariety,
                            "Broj čokota": _this.currencyFormat(
                              entry.numberOfPlants
                            ),
                            Površina: _this.currencyFormatDE(entry.surface),
                            Količina: _this.currencyFormatDE(
                              entry.harvestQuantityInT
                            ),
                          };

                          _this.json_data.push(objekat);

                          entry.vineyardDataDtos.forEach(function (entry1) {
                            let objekat1 = {
                              Rb: "",
                              "Sorta/Vinograd": entry1.grapeVariety,
                              "Broj čokota": _this.currencyFormat(
                                entry1.numberOfPlants
                              ),
                              Površina: _this.currencyFormatDE(entry1.surface),
                              Količina: _this.currencyFormatDE(
                                entry1.harvestQuantityInT
                              ),
                            };

                            _this.json_data.push(objekat1);
                          });
                        });

                        let objekat = {
                          Rb: "",
                          "Sorta/Vinograd": "Ukupna vrednost:",
                          "Broj čokota": this.currencyFormat(this.totalCokota),
                          Površina: this.currencyFormatDE(this.totalPovrsina),
                          Količina: this.currencyFormatDE(this.totalUbrano),
                        };

                        this.json_data.push(objekat);

                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    getAllRadnici() {
      this.isLoading = true;

      this.naziv_fajla = "utrosak_materijala.xls";
      this.naslov = this.labNaslov4;

      if (this.radios === "0") {
        this.headers_states = [
          { text: "Rb.", value: "", align: "center", sortable: false },
          {
            text: "Sorta/" + this.labVinograd,
            value: "grapeVariety",
            align: "center",
            sortable: true,
          },
          {
            text: this.labBrojCokota,
            value: "numberOfPlants",
            align: "right",
            sortable: true,
          },
          {
            text: "Površina",
            value: "surface",
            align: "right",
            sortable: true,
          },
          {
            text: "Ubrano",
            value: "harvestQuantityInT",
            align: "right",
            sortable: true,
          },
          {
            text: "Repromaterijal",
            value: "materialCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterne mašine",
            value: "externalMechanizationCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterni radnici",
            value: "externalWorkForceCosts",
            align: "right",
            sortable: true,
          },
          {
            text: "Gorivo",
            value: "fuelConsumption",
            align: "right",
            sortable: true,
          },
          {
            text: "Ukupno",
            value: "",
            align: "right",
            sortable: false,
          },
        ];

        this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Repromaterijal": "Number","Eksterne mašine": "Number","Eksterni radnici": "Number","Gorivo": "Number","Ukupno": "Number"}');

        this.json_fields_type = [
          "String",
          "String",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
        ];
      } else {
        this.headers_states = [
          { text: "Rb.", value: "", align: "center", sortable: false },
          {
            text: "Sorta/" + this.labVinograd,
            value: "grapeVariety",
            align: "center",
            sortable: true,
          },
          {
            text: this.labBrojCokota,
            value: "numberOfPlants",
            align: "right",
            sortable: true,
          },
          {
            text: "Površina",
            value: "surface",
            align: "right",
            sortable: true,
          },
          {
            text: "Ubrano",
            value: "harvestQuantityInT",
            align: "right",
            sortable: true,
          },
          {
            text: "Sopstvene mašine",
            value: "interanlMechanizationHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterne mašine",
            value: "exteranlMechanizationHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Sopstveni radnici",
            value: "interanlWorkForceHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Eksterni radnici",
            value: "exteranlWorkForceHours",
            align: "right",
            sortable: true,
          },
          {
            text: "Gorivo",
            value: "fuelConsumption",
            align: "right",
            sortable: true,
          },
          {
            text: "Voda",
            value: "waterConsumption",
            align: "right",
            sortable: true,
          },
        ];

        this.json_fields = JSON.parse('{"Rb": "String","Sorta/' + this.labVinograd + '": "String","' + this.labBrojCokota + '": "Number","Površina": "Number","Ubrano": "Number","Sopstvene mašine": "Number","Eksterne mašine": "Number","Sopstveni radnici": "Number","Eksterni radnici": "Number","Gorivo": "Number","Voda": "Number"}');

        this.json_fields_type = [
          "String",
          "String",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
          "Number",
        ];
      }

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_vineyard_to_select = "";

      this.vinogradiFilter = "";

      if (this.vineyard_select !== undefined && this.vineyard_select !== null) {
        this.vineyard_select.forEach(function (entry) {
          pom_vineyard_to_select =
            pom_vineyard_to_select + "vineyardId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_operation_types_to_select = "";
      this.fiterTipoviOperacija = "";

      if (
        this.operation_type_to_select !== undefined &&
        this.operation_type_to_select !== null
      ) {
        this.operation_type_to_select.forEach(function (entry) {
          pom_operation_types_to_select =
            pom_operation_types_to_select +
            "operationType=" +
            prevediOperacije3SaSrpskog(entry) +
            "&";

          _this.fiterTipoviOperacija =
            _this.fiterTipoviOperacija + entry + ", ";
        });
      }

      var pom_grape_variety_select = "";
      this.fiterSorteGrozdja = "";

      if (
        this.grape_variety_select !== undefined &&
        this.grape_variety_select !== null
      ) {
        this.grape_variety_select.forEach(function (entry) {
          pom_grape_variety_select =
            pom_grape_variety_select + "grapeVarietyId=" + entry.id + "&";

          _this.fiterSorteGrozdja = _this.fiterSorteGrozdja + entry.name + ", ";
        });
      }

      var pom_vinery_block_select = "";
      this.fiterParcele = "";

      if (
        this.vinery_block_select !== undefined &&
        this.vinery_block_select !== null
      ) {
        this.vinery_block_select.forEach(function (entry) {
          pom_vinery_block_select =
            pom_vinery_block_select + "blockId=" + entry.id + "&";

          _this.fiterParcele = _this.fiterParcele + entry.name + ", ";
        });
      }

      var pom_operation_to_select = "";
      this.fiterOperacija = "";

      if (
        this.operation_to_select !== undefined &&
        this.operation_to_select !== null
      ) {
        this.operation_to_select.forEach(function (entry) {
          pom_operation_to_select =
            pom_operation_to_select + "operationId=" + entry.id + "&";

          _this.fiterOperacija = _this.fiterOperacija + entry.name + ", ";
        });
      }

      // let sortiranje = "";
      // if (this.paginationKartica.sortBy !== "") {
      //   let orderovanje = "";
      //   if (this.paginationKartica.descending) orderovanje = "desc";
      //   else orderovanje = "asc";

      //   sortiranje =
      //     "sort=" +
      //     this.paginationKartica.sortBy.replace("documentNumber", "number") +
      //     "&order=" +
      //     orderovanje;
      // }

      let urlLoc =
        "/vineyard_operation_execution/grape_harvested_costs?" +
        pom_operation_types_to_select +
        pom_operation_to_select +
        pom_vineyard_to_select +
        pom_grape_variety_select +
        pom_vinery_block_select;

      // if (
      //   urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
      //   urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      // )
      //   urlLoc = urlLoc + sortiranje;
      // else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      setTimeout(() => {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              urlLoc +
              strDate +
              strDateDo,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.total = 0;
            this.totalUbrano = 0;
            this.totalCokota = 0;
            this.totalPovrsina = 0;
            this.totalSopstveniRadnici = 0;
            this.totalEksterniRadnici = 0;
            this.totalEksterneMasine = 0;
            this.totalSopstveneMasine = 0;
            this.totalGoriva = 0;
            this.totalVoda = 0;

            this.items_states = response.data;

            let _this = this;
            this.json_data = [];

            let rbr = 0;

            response.data.forEach(function (entry) {
              rbr = rbr + 1;

              _this.total =
                _this.total +
                entry.exteranlWorkForceHours +
                entry.materialCosts +
                entry.exteranlMechanizationHours +
                entry.fuelConsumption +
                entry.waterConsumption;

              _this.totalUbrano = _this.totalUbrano + entry.harvestQuantityInT;
              _this.totalCokota = _this.totalCokota + entry.numberOfPlants;
              _this.totalPovrsina = _this.totalPovrsina + entry.surface;
              _this.totalSopstveneMasine =
                _this.totalSopstveneMasine +
                (_this.radios === "0"
                  ? entry.materialCosts
                  : entry.interanlMechanizationHours);
              _this.totalSopstveniRadnici =
                _this.totalSopstveniRadnici +
                (_this.radios === "0" ? 0 : entry.interanlWorkForceHours);

              _this.totalEksterneMasine =
                _this.totalEksterneMasine +
                (_this.radios === "0"
                  ? entry.externalMechanizationCosts
                  : entry.exteranlMechanizationHours);

              _this.totalEksterniRadnici =
                _this.totalEksterniRadnici +
                (_this.radios === "0"
                  ? entry.externalWorkForceCosts
                  : entry.exteranlWorkForceHours);
              _this.totalGoriva =
                _this.totalGoriva +
                (_this.radios === "0"
                  ? entry.fuelCosts
                  : entry.fuelConsumption);
              _this.totalVoda = _this.totalVoda + entry.waterConsumption;

              let objekat = {
                Rb: rbr,
                "Sorta/Vinograd": entry.vineyard,
                "Broj čokota": _this.currencyFormat(entry.numberOfPlants),
                Površina: _this.currencyFormatDE(entry.surface),
                Ubrano: _this.currencyFormatDE(entry.harvestQuantityInT),
                Repromaterijal: _this.currencyFormatDE(entry.materialCosts),
                "Eksterne mašine": _this.convertMinToTime(
                  entry.exteranlMechanizationHours
                ),
                "Eksterni radnici": _this.convertMinToTime(
                  entry.exteranlWorkForceHours
                ),
                Gorivo: _this.currencyFormatDE(entry.fuelConsumption),
                Voda: _this.currencyFormatDE(entry.waterConsumption),
              };

              _this.json_data.push(objekat);

              entry.vineyardPerGrapeVarietyData.forEach(function (entry1) {
                let objekat1 = {
                  Rb: "",
                  "Sorta/Vinograd": entry1.grapeVariety,
                  "Broj čokota": _this.currencyFormat(entry1.numberOfPlants),
                  Površina: _this.currencyFormatDE(entry1.surface),
                  Ubrano: _this.currencyFormatDE(entry1.harvestQuantityInT),
                  Repromaterijal: _this.currencyFormatDE(entry1.materialCosts),
                  "Eksterne mašine": _this.convertMinToTime(
                    entry1.exteranlMechanizationHours
                  ),
                  "Eksterne radnici": _this.convertMinToTime(
                    entry1.exteranlWorkForceHours
                  ),
                  Gorivo: _this.currencyFormatDE(entry1.fuelConsumption),
                  Voda: _this.currencyFormatDE(entry1.waterConsumption),
                };

                _this.json_data.push(objekat1);
              });
            });

            let objekat = {
              Rb: "",
              "Sorta/Vinograd": "Ukupna vrednost:",
              "Broj čokota": this.currencyFormat(this.totalCokota),
              Površina: this.currencyFormatDE(this.totalPovrsina),
              Ubrano: this.currencyFormatDE(this.totalUbrano),
              Repromaterijal: this.convertMinToTime(this.totalSopstveneMasine),
              "Eksterne mašine": this.convertMinToTime(
                this.totalEksterneMasine
              ),
              "Eksterni radnici": this.convertMinToTime(
                this.totalEksterniRadnici
              ),
              "Sopstveni radnici": this.convertMinToTime(
                this.totalSopstveniRadnici
              ),
              Gorivo: this.currencyFormatDE(this.totalGoriva),
              Voda: this.currencyFormatDE(this.totalVoda),
            };

            this.json_data.push(objekat);

            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlLoc +
                          strDate +
                          strDateDo +
                          "&page=" +
                          this.izabranaStranica +
                          "&offset=" +
                          this.paginationKartica.rowsPerPage,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.total = 0;
                        this.totalUbrano = 0;
                        this.totalCokota = 0;
                        this.totalPovrsina = 0;
                        this.totalSopstveniRadnici = 0;
                        this.totalEksterniRadnici = 0;
                        this.totalEksterneMasine = 0;
                        this.totalSopstveneMasine = 0;
                        this.totalGoriva = 0;
                        this.totalVoda = 0;

                        this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];

                        let rbr = 0;

                        response.data.forEach(function (entry) {
                          rbr = rbr + 1;

                          _this.total =
                            _this.total +
                            entry.exteranlWorkForceHours +
                            entry.materialCosts +
                            entry.exteranlMechanizationHours +
                            entry.fuelConsumption +
                            entry.waterConsumption;

                          _this.totalUbrano =
                            _this.totalUbrano + entry.harvestQuantityInT;
                          _this.totalCokota =
                            _this.totalCokota + entry.numberOfPlants;
                          _this.totalPovrsina =
                            _this.totalPovrsina + entry.surface;
                          _this.totalSopstveneMasine =
                            _this.totalSopstveneMasine +
                            (_this.radios === "0"
                              ? entry.materialCosts
                              : entry.interanlMechanizationHours);
                          _this.totalSopstveniRadnici =
                            _this.totalSopstveniRadnici +
                            (_this.radios === "0"
                              ? 0
                              : entry.interanlWorkForceHours);
                          _this.totalEksterneMasine =
                            _this.totalEksterneMasine +
                            entry.exteranlMechanizationHours;

                          _this.totalEksterniRadnici =
                            _this.totalEksterniRadnici +
                            entry.exteranlWorkForceHours;
                          _this.totalGoriva =
                            _this.totalGoriva + entry.fuelConsumption;
                          _this.totalVoda =
                            _this.totalVoda + entry.waterConsumption;

                          let objekat = {
                            Rb: rbr,
                            "Sorta/Vinograd": entry.vineyard,
                            "Broj čokota": _this.currencyFormat(
                              entry.numberOfPlants
                            ),
                            Površina: _this.currencyFormatDE(entry.surface),
                            Ubrano: _this.currencyFormatDE(
                              entry.harvestQuantityInT
                            ),
                            Repromaterijal: _this.currencyFormatDE(
                              entry.materialCosts
                            ),
                            "Eksterne mašine": _this.convertMinToTime(
                              entry.exteranlMechanizationHours
                            ),
                            "Eksterni radnici": _this.convertMinToTime(
                              entry.exteranlWorkForceHours
                            ),
                            Gorivo: _this.currencyFormatDE(
                              entry.fuelConsumption
                            ),
                            Voda: _this.currencyFormatDE(
                              entry.waterConsumption
                            ),
                          };

                          _this.json_data.push(objekat);

                          entry.vineyardPerGrapeVarietyData.forEach(function (
                            entry1
                          ) {
                            let objekat1 = {
                              Rb: "",
                              "Sorta/Vinograd": entry1.grapeVariety,
                              "Broj čokota": _this.currencyFormat(
                                entry1.numberOfPlants
                              ),
                              Površina: _this.currencyFormatDE(entry1.surface),
                              Ubrano: _this.currencyFormatDE(
                                entry1.harvestQuantityInT
                              ),
                              Repromaterijal: _this.currencyFormatDE(
                                entry1.materialCosts
                              ),
                              "Eksterne mašine": _this.convertMinToTime(
                                entry1.exteranlMechanizationHours
                              ),
                              "Eksterne radnici": _this.convertMinToTime(
                                entry1.exteranlWorkForceHours
                              ),
                              Gorivo: _this.currencyFormatDE(
                                entry1.fuelConsumption
                              ),
                              Voda: _this.currencyFormatDE(
                                entry1.waterConsumption
                              ),
                            };

                            _this.json_data.push(objekat1);
                          });
                        });

                        let objekat = {
                          Rb: "",
                          "Sorta/Vinograd": "Ukupna vrednost:",
                          "Broj čokota": this.currencyFormat(this.totalCokota),
                          Površina: this.currencyFormatDE(this.totalPovrsina),
                          Ubrano: this.currencyFormatDE(this.totalUbrano),
                          Repromaterijal: this.convertMinToTime(
                            this.totalSopstveneMasine
                          ),
                          "Eksterne mašine": this.convertMinToTime(
                            this.totalEksterneMasine
                          ),
                          "Eksterni radnici": this.convertMinToTime(
                            this.totalEksterniRadnici
                          ),
                          "Sopstveni radnici": this.convertMinToTime(
                            this.totalSopstveniRadnici
                          ),
                          Gorivo: this.currencyFormatDE(this.totalGoriva),
                          Voda: this.currencyFormatDE(this.totalVoda),
                        };

                        this.json_data.push(objekat);

                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    clear() {
      

      if(this.$refs.form !== undefined)
        this.$refs.form.reset();

      if(this.$refs.form1 !== undefined)
        this.$refs.form1.reset();

      if(this.$refs.element1 !== undefined)
        this.$refs.element1.reset();

      this.datumOdFiter = "";
      this.datumDoFiter = "";

      this.setDate();

      this.vinogradiFilter = "";
      this.fiterSorteGrozdja = "";

      this.clear_init();
    },
    changeSortKartica(column) {
      if (this.items_states.length > 0)
        if (typeof column !== "undefined")
          if (column !== "funkcije")
            if (this.paginationKartica.sortBy === column) {
              this.paginationKartica.descending =
                !this.paginationKartica.descending;
            } else {
              this.paginationKartica.sortBy = column;
              this.paginationKartica.descending = false;
            }
    },
    stampaj() {
      this.preracunajVrednostiZaStampu();

      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        if (
          _this.datumOdFiter !== "" ||
          _this.datumDoFiter !== "" ||
          _this.vinogradiFilter !== "" ||
          _this.fiterSorteGrozdja !== ""
        ) {
          let pomocni_tekst = "";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.vinogradiFilter !== "") {
            pomocni_tekst =
              pomocni_tekst +
              this.labVinograd + ": " +
              _this.vinogradiFilter.substring(
                0,
                _this.vinogradiFilter.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterSorteGrozdja !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Sorta: " +
              _this.fiterSorteGrozdja.substring(
                0,
                _this.fiterSorteGrozdja.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (
              val === null ||
              val === 0 ||
              val === "0,00" ||
              val === "0.00" ||
              val === "00:00" ||
              val === "0"
            )
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (_this.json_fields_type[pomJ] === "Number") {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 70%";
        tbl.style.width = "30%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
  },
  mounted() {
    this.getVineYards();
    this.getYears();
    this.getGrapeVarieties();

    this.clear();
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if(!this.vinarija){
    this.labVinograd = "Zasad";
    this.labPocokotu = "Po biljci";
    this.labFusnota = "Sve novčane vrednosti su u RSD po kilogramu ploda";
    this.labAmortVinograda = "Amort. zasada";
    this.labCenaGrozdja = "Cena ploda";
    this.labBrojCokota = "Broj biljaka";
    this.labNaslov1 = "Količine ubranog ploda";
    this.labNaslov2 = "Količine ubranog ploda - po biljci";
    this.labNaslov3 = "Količine ubranog ploda - po hektaru";
    this.labNaslov4 = "Količine u zasadu po sorti ploda";
    this.labNaslov5 = "Količina ubranog ploda utrošci po toni - vrednosti";
    this.labNaslov6 = "Količina ubranog ploda utrošci po toni - količine";
    this.labNaslov7 = "Ubrano plodova u zasadu i obračun cena za ";
  }
  else
  {
    this.labVinograd = "Vinograd";
    this.labPocokotu = "Po čokotu";
    this.labFusnota = "Sve novčane vrednosti su u RSD po kilogramu grožđa";
    this.labAmortVinograda = "Amort. vinograda";
    this.labCenaGrozdja = "Cena grožđa";
    this.labBrojCokota = "Broj čokota";
    this.labNaslov1 = "Količine ubranog grožđa";
    this.labNaslov2 = "Količine ubranog grožđa - po čokotu";
    this.labNaslov3 = "Količine ubranog grožđa - po hektaru";
    this.labNaslov4 = "Količine u vinogradu po sorti grožđa";
    this.labNaslov5 = "Količina ubranog grožđa utrošci po toni - vrednosti";
    this.labNaslov6 = "Količina ubranog grožđa utrošci po toni - količine";
    this.labNaslov7 = "Ubrano grožđe u vinogradima i obračun cena za ";
  }
  }
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 5%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 95%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}

@media print {
  table,
  div {
    break-inside: avoid;
  }
}

thead {
  display: table-header-group;
}
tfoot {
  display: table-row-group;
}
tr {
  page-break-after: always !important;
  page-break-before: always !important;
  page-break-inside: auto !important;
}

div {
  page-break-inside: avoid;
}
#nextpage1 {
  page-break-before: always;
}

.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  max-height: 40px;
}
</style>